import {
  UserListView,
  UserNewView,
  UserEditView,
  UserShowView,
} from '@/views/authenticated/users';

export default [
  {
    path: '/users',
    name: 'app_user_list',
    meta: { title: 'Users', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: UserListView,
  },
  {
    path: '/users/new',
    name: 'app_user_new',
    meta: { title: 'Add a User', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: UserNewView,
  },
  {
    path: '/users/:user/edit',
    name: 'app_user_edit',
    meta: { title: 'Edit User', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: UserEditView,
  },
  {
    path: '/users/:user/show',
    name: 'app_user_show',
    meta: { title: 'Show User', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: UserShowView,
  },
];
